import { Helmet } from 'react-helmet-async';

export const SEO = ({
  title = 'Minchio Brothers - Professional Real Estate Photography & Videography',
  description = 'Award-winning videography and photography services for Real Estate, Commercial, and Social Media in Australia. Creating cinematic stories that captivate audiences.',
  keywords = 'real estate photography, property photography, commercial videography, social media content, drone photography, virtual tours, Australia photography',
  ogImage = 'https://minchiobrothers.au/og-image.jpg',
  ogType = 'website',
  canonicalUrl,
  structuredData
}) => {
  const siteUrl = 'https://minchiobrothers.au';
  const fullCanonicalUrl = canonicalUrl ? `${siteUrl}${canonicalUrl}` : siteUrl;

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={fullCanonicalUrl} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={ogType} />
      <meta property="og:url" content={fullCanonicalUrl} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:site_name" content="Minchio Brothers Productions" />
      <meta property="og:locale" content="en_AU" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={fullCanonicalUrl} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />

      {/* Additional Meta Tags */}
      <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
      <meta name="language" content="English" />
      <meta name="revisit-after" content="7 days" />
      <meta name="author" content="Minchio Brothers Productions" />
      
      {/* Geographic Tags */}
      <meta name="geo.region" content="AU" />
      <meta name="geo.placename" content="Australia" />

      {/* Structured Data */}
      {structuredData && (
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      )}
    </Helmet>
  );
};

export default SEO;
